<template>
<div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
    <w-header-search-button @click="onClickSetSearchToolVisible"></w-header-search-button>
  </el-row>
  <el-table-wrapper v-loading="loading" :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" ref="table"
  :pagination="true" :column-default="columnDefault">
  </el-table-wrapper>
</div>
</template>

<script>
import msgUtil from '@/utils/message';
import { analysisTimeType } from '@/constants/performance';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

const columns = [{
  prop: 'localAddress',
  label: '로컬 IP 주소',
  sortable: true,
  showOverflowTooltip: true,
  searchable: true,
  formatter: this.getTableValueAfterCheckEmpty,
}, {
  prop: 'localPort',
  label: '로컬 포트',
  sortable: true,
  showOverflowTooltip: true,
  searchable: true,
  formatter: this.getTableValueAfterCheckEmpty,
}, {
  prop: 'remoteAddress',
  label: '원격지 IP 주소',
  sortable: true,
  showOverflowTooltip: true,
  searchable: true,
  formatter: this.getTableValueAfterCheckEmpty,
}, {
  prop: 'remotePort',
  label: '원격지 포트',
  sortable: true,
  showOverflowTooltip: true,
  searchable: true,
  formatter: this.getTableValueAfterCheckEmpty,
}, {
  prop: 'state',
  label: '상태',
  sortable: true,
  showOverflowTooltip: true,
  searchable: true,
  formatter: this.getTableValueAfterCheckEmpty,
}];

export default {
  name: 'WTcpInfoTable',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      columnDefault,
      loading: false,
      tableData: [],
      checkDatetime: null,
      columns,
      showSearchTool: false,
    };
  },
  methods: {
    /**
     * TCP 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
        params.baselineDatetime = this.plotLineDatetime;
        params.managetypeId = 'NMS';

        this.loading = true;
        netdeviceTableInfoAPI.getTcpInfoList(params).then((response) => {
          if (response.data.success === true) {
            const snapshotData = response.data.data;
            this.tableData = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.loading = false;
        });
      } else {
        this.loading = true;
        netdeviceTableInfoAPI.getCurrentTcpInfoList(params).then((response) => {
          if (response.data.success === true) {
            this.tableData = response.data.data;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'TCP 정보', false));
    },
    /**
     * [changeDataFlag 검색기능 show]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onClickSetSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/table/TcpInfoTable.vue